import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';

import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';

import { getVesselSales } from 'actions/vessels/sales';

import Item from './Item';

const styles = {
    radioGroup: {
        margin: '20px 0',
    },
    radioButton: {
        display: 'inline-block',
        verticalAlign: 'middle',
        width: '25%',
    },
    paginationContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        padding: '.5em',
        fontSize: '.75em'
    },
    paginationSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    paginationText: {
        margin: '0 1.25em'
    },
    paginationSelect: {
        width: 75,
        fontSize: '1em'
    },
    navigationLeft: {
        marginRight: '.5em',
        cursor: 'pointer'
    },
    navigationLeftFirstPage: {
        marginRight: '.5em',
        color: 'rgba(0,0,0,0.26)'
    },
    navigationRight: {
        margin: '0 .5em',
        cursor: 'pointer'
    },
    navigationRightLastPage: {
        margin: '0 .5em',
        color: 'rgba(0,0,0,0.26)'
    }
};

class List extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            filters: {
                search: '',
                // eh: [],
            },
        };

        this.updateRows = this.updateRows.bind(this);
        this.handleSearch = this.handleSearch.bind(this);

        this.prevPage = this.prevPage.bind(this);
        this.nextPage = this.nextPage.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.getVesselSales({
            page: 1,
            filters: {},
        });
    }

    nextPage() {
        this.setState({
            page: this.props.vesselSales.next,
        }, () => {
            this.updateRows(this.state);
        });
    }

    prevPage() {
        this.setState({
            page: this.props.vesselSales.previous,
        }, () => {
            this.updateRows(this.state);
        });
    }

    updateRows(state) {
        this.props.getVesselSales({
            page: state.page,
            filters: {
                search: state.filters.search.length !== 0 ? state.filters.search : undefined,
            },
        });
    }

    handleSearch() {
        this.setState({
            page: 1,
            filters: {
                ...this.state.filters,
                search: this.refs.search.input.value,
            },
        }, () => {
            this.updateRows(this.state);
        });
    }

    render() {
        const vesselSales = this.props.vesselSales;
        const vesselSalesItems = vesselSales.data;
        if (!vesselSalesItems) {
            return null;
        }

        return (
            <div>
                <div className='filter'>
                    <div className='filter-row'>
                        <div className='search filter-column' style={{ width: '100%', justifyContent: 'space-between', }}>
                            <div>
                                <TextField
                                    defaultValue={this.state.search}
                                    floatingLabelText='Search'
                                    ref='search'
                                    onKeyPress={(event) => {
                                        if (event.charCode === 13) {
                                            event.preventDefault();
                                            this.handleSearch();
                                        }
                                    }}
                                />

                                <RaisedButton
                                    label='Search'
                                    style={{ fontSize: '13px', margin: '0 0 0 50px' }}
                                    primary
                                    onClick={this.handleSearch}
                                />
                            </div>
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                <IconButton
                                    iconStyle={styles.navigationLeft}
                                    name='navigationLeft'
                                    onClick={this.prevPage}
                                >
                                    <ChevronLeft />
                                </IconButton>
                                <div className='item'>Page: {this.state.page}</div>
                                <IconButton
                                    iconStyle={styles.navigationRight}
                                    name='navigationRight'
                                    onClick={this.nextPage}
                                >
                                    <ChevronRight />
                                </IconButton>
                            </span>
                        </div>                        
                    </div>

                    <div>
                        <ul className='list-requests'>
                            {
                                vesselSalesItems.map(item => <Item key={item._id} item={item} />)
                            }
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => {
        return {
            vesselSales: state.vesselSales,
        };
    },
    dispatch => bindActionCreators({
        getVesselSales,
    },
    dispatch),
)(List);



// WEBPACK FOOTER //
// ./app/components/Vessels/Sales/List.jsx